import { createContext } from "react";

export const PortalWorkspaceLoadContext = createContext({
  portalWorkspaceLoaded: false,
  setPortalWorkspaceLoaded: () => {},
  setShowLoader: () => {}
})